module.exports = __webpack_public_path__ + "static/media/MF2_0196.fdab5480.webp";